import React, { useContext, useEffect, useState } from "react";
import CustomForm from "../../../CommonComponents/CustomForm/CustomForm";
import { csrfToken } from "../../../../utils/csrfTokenUtils";
import { networkService } from "../../../config/axios";
import UserInfoContext from "../../../../utils/userInfoContext";
import { AdminModalFooter } from "../../../Admin/Shared";

const ManageDomainName = ({ setShow, companyId, domain }) => {
  const { setShowNotifications } = useContext(UserInfoContext)
  const [error, setError] = useState("");
  const [companyDomain, setCompanyDomain] = useState("");
  const handleChange = ({ target: { value } }) => {
    setError("");
    setCompanyDomain(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!companyDomain) {
      setError("Please add Domain");
    } else {
      const url = domain?.id ? `admin/company_domains/${domain?.id}.json` : 'admin/company_domains.json'
      const data = {
        authenticity_token: csrfToken(),
        company_domain: {
          name: companyDomain,
          company_id: companyId,
        },
        ...(domain?.id && { id: domain?.id })
      };
      await networkService(
        url,
        domain?.id ? 'PATCH' : 'POST',
        data
      ).then((response) => {
        if (response.status == 200 || response?.status == 201) {
          setShow('list');
          setShowNotifications({
            showToast: true,
            toastType: "success",
            toastMessage: `Domains ${domain?.id ? 'updated' : 'added'}`,
          })
        }
      }).
        catch(() => {
          setShowNotifications({
            showToast: true,
            toastType: 'danger',
            toastMessage: "Something went wrong"
          })
        });
    }
  };

  useEffect(() => {
    if (domain?.name) {
      setCompanyDomain(domain?.name)
    } else {
      setCompanyDomain('')
    }
  }, [domain])

  return (
    <div className="domain-form-container">
      <CustomForm>
        <div className="admin-form-group">
          <label htmlFor="domain-name" className="admin-form-label">Domain Name</label>
          <div className="domain-input-wrapper">
            <span className="domain-prefix">@</span>
            <input
              id="domain-name"
              type="text"
              placeholder="Enter domain name"
              value={companyDomain}
              name="name"
              onChange={handleChange}
              required
            />
          </div>
          {error && <p className="admin-form-error">{error}</p>}
        </div>

        <AdminModalFooter
          onCancel={() => setShow('list')}
          onSubmit={handleSubmit}
          submitText={domain?.id ? "Update" : "Save"}
        />
      </CustomForm>
    </div>
  );
};

export default ManageDomainName;